import {CalendarEvent} from '../components/SaveToCalendar/types';
import formatDateForCalendarUrl from './formatDateForCalendarUrl';
import getEndTime from './getEndTime';

function handleDownloadIcsCalendarFile(calendarEvent: CalendarEvent) {
	const startDate = formatDateForCalendarUrl(calendarEvent.startDate);
	const endDate = formatDateForCalendarUrl(getEndTime(calendarEvent));

	const calendarUrl = encodeURI(
		`data:text/calendar;charset=utf8,${[
			'BEGIN:VCALENDAR',
			'VERSION:2.0',
			'BEGIN:VEVENT',
			`URL:${document.URL}`,
			`DTSTART:${startDate || ''}`,
			`DTEND:${endDate || ''}`,
			`SUMMARY:${calendarEvent.title || ''}`,
			`DESCRIPTION:${calendarEvent.description || ''}`,
			`LOCATION:${calendarEvent.address || ''}`,
			'END:VEVENT',
			'END:VCALENDAR',
		].join('\n')}`,
	);

	const link = document.createElement('a');
	link.setAttribute('href', calendarUrl);
	link.setAttribute('download', 'event.ics');
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}

export default handleDownloadIcsCalendarFile;
